import { gatewayPhone } from "../../../../../gateways/gatewayPhone";
import { BackendContact } from "@components/virtual-receptionist/contacts/types/bulk-resolver.types";
import { TranscriptionRecord } from "./transcription.action";

export type RecordedCallRecord = {
    uid: string;
    from: string | null;
    to: string | null;
    direction: string | null;
    status: string | null;
    finalStatus: string | null;
    callSid: string | null;
    durationSeconds: number | null;
    recording: {
        sid: string | null;
        audioUrl: string | null;
        s3Key: string | null;
        contentType: string | null;
        durationSeconds: number | null;
    } | null;
    answeredAgent: string | null;
    transcription?: TranscriptionRecord | null;
    provider: string | null;
    createdAt: string;
    updatedAt: string;
    contact?: BackendContact | null;
};

export type GetRecordedCallsParams = {
    page?: number;
    limit?: number;
    phoneNumber?: string;
};

export type GetRecordedCallsResponse = {
    data: RecordedCallRecord[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
};

export const getRecordedCalls = async ({
    page = 1,
    limit = 10,
    phoneNumber,
}: GetRecordedCallsParams = {}): Promise<GetRecordedCallsResponse> => {
    const response = await gatewayPhone.get<GetRecordedCallsResponse>(
        "/calls/recorded",
        {
            params: { page, limit, ...(phoneNumber && { phoneNumber }) },
        }
    );

    return response.data;
};